const SysValidations = {
  fieldRequired: sFieldName => `El campo "${sFieldName}" es requerido`,
  fieldInvalid: sFieldName => `El campo "${sFieldName}" es inválido`,
};

export default SysValidations;
